import { Box, Divider } from '@mui/material';
import Typography from '@mui/material/Typography';

type DynamicInvoiceDetailProps = {
  label: string;
  value: string | number;
  showDivider?: boolean;
};
    
export const DynamicInvoiceDetail: React.FC<DynamicInvoiceDetailProps> = ({ label, value, showDivider = true }) => (
  <>
    <Box sx={{ display: 'flex' }}>
      <Typography
        variant="subtitle2"
        color="textSecondary"
        fontSize="14px"
      >
        {label}
      </Typography>

      <Typography
        variant="subtitle2"
        color="textPrimary"
        fontSize="14px"
        sx={{ ml: 1 }}
      >
        {value}
      </Typography>
      
      {
        showDivider && (
          <Divider
            sx={{ marginLeft: 2 }}
            orientation="vertical"
            flexItem
          />
        )
      }
    </Box>
  </>
);